import { MFAStatus } from 'protocol/api/auth/dto_auth_pb';

import { EnforceBlock, MFAPermissions } from '../config';

// Mirrors the backend: on admin targets MFA_CanEditAdmin replaces
// MFA_CanEnforce and is needed on top of MFA_CanSetup
export const canManageTargetMFA = (
  status: MFAStatus | null,
  permissions: MFAPermissions,
): { canEnforce: boolean; canRemove: boolean; enforceBlock?: EnforceBlock } => {
  if (!status) {
    return { canEnforce: false, canRemove: false };
  }

  const isAdminTarget = status.HasAdminPermissions;

  let enforceBlock: EnforceBlock | undefined;
  if (isAdminTarget && !permissions.canEditAdmin) {
    enforceBlock = 'adminAccount';
  } else if (!isAdminTarget && !permissions.canEnforce) {
    enforceBlock = 'noPermission';
  }

  return {
    canEnforce: !enforceBlock,
    enforceBlock,
    canRemove:
      permissions.canSetup &&
      (!isAdminTarget || permissions.canEditAdmin) &&
      status.Enabled,
  };
};
